import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllEmployees } from "../features/employee/employeeSlice";
import { toast } from "react-toastify";
import { FaRegPlusSquare } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  getAllUsers,
  logout,
  updateUser,
  resetUserUpdate,
  getUserById,
} from "../features/user/userSlice";
import Loader from "../components/Loader";

const MasterSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");

  const [allUsers, setAllUsers] = useState([]);

  const [openPassport, setOpnePassport] = useState(false);
  const [openVisa, setOpenVisa] = useState(false);
  const [openAgent, setOpenAgent] = useState(false);
  const [openOfficeAgent, setOpenOfficeAgent] = useState(false);
  const [openDeliveryOffice, setOpenDeliveryOffice] = useState(false);
  const [openAccounts, setOpenAccounts] = useState(false);

  const [permissions, setPermissions] = useState([]);

  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const [selectedUser, setSelectedUser] = useState({});

  //user selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    users,

    isGetAllUsersLoading,
    isGetAllUsersError,
    isGetAllUsersSuccess,
    getAllUsersErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.userType !== "admin") {
      toast.error("You are not authorized to access this page", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (!Array.isArray(permissions)) {
      setPermissions([]);
    }
  }, [permissions]);

  // User List
  useEffect(() => {
    if (isGetAllUsersError) {
      toast.error(getAllUsersErrorMessage, { position: "top-center" });
    } else if (isGetAllUsersSuccess) {
      setAllUsers(users);
    } else {
      dispatch(getAllUsers());
    }
  }, [
    dispatch,
    isGetAllUsersError,
    isGetAllUsersSuccess,
    getAllUsersErrorMessage,
    users,
  ]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Access Granted Successfully", { position: "top-center" });
    }
  }, [isUpdateError, isUpdateSuccess, updateErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetUserUpdate());
    };
  }, [dispatch]);

  // function to select the user and get the user by id
  const handleEmployeeSelect = (e) => {
    if (e.target.value !== "") {
      const userSelect = allUsers.find(
        (user) => user.userName === e.target.value
      );
      setSelectedUser(userSelect);
      setUserName(e.target.value);
      if (selectedUser) {
        setPermissions(selectedUser.permissions);
        setSelectedPermissions(selectedUser.permissions);
        // dispatch(getUserById(selectedUser._id));
      }
    } else {
      // If no user is selected, grant all permissions and user and user id is empty
      setPermissions([]);
      setSelectedPermissions([]);
      setSelectedUser({});
      setUserName("");
    }
  };

  useEffect(() => {
    if (selectedUser) {
      setPermissions(selectedUser.permissions);
      setSelectedPermissions(selectedUser.permissions);
    }
  }, [selectedUser]);

  // const handleCheckboxChange = (permission) => {
  //   // Create a copy of the permissions array to avoid mutating state directly
  //   const updatedPermissions = [...permissions];

  //   // Check if the permission is already in the permissions array
  //   const permissionIndex = updatedPermissions.indexOf(permission);

  //   // If the permission is already in the array, remove it
  //   if (permissionIndex !== -1) {
  //     updatedPermissions.splice(permissionIndex, 1);
  //   } else {
  //     // If the permission is not in the array, add it
  //     updatedPermissions.push(permission);
  //   }

  //   // Update the permissions state with the modified array
  //   setPermissions(updatedPermissions);
  // };

  // function to push the permissions to the permissions array if checkbox is checked. if no checkbox is cheked return empty array
  const handleCheckboxChange = (permission) => {
    if (!permissions) {
      setPermissions([]);
      setSelectedPermissions([]);
    }

    // if no user is selected checkbox cannot be checked
    // if (!selectedUser) {
    //   toast.error("Please select a User to proceed!", {
    //     position: "top-center",
    //   });
    //   return;
    // }

    // if checkbox is checked, push the permission to the permissions array
    if (selectedPermissions.includes(permission)) {
      const updatedPermissions = selectedPermissions.filter(
        (perm) => perm !== permission
      );
      setSelectedPermissions(updatedPermissions);
    } else {
      setSelectedPermissions([...selectedPermissions, permission]);
    }
  };

  // Saving the selected permissions to the selectedPermissions array (Local State)
  // const handleCheckboxChange = (permission) => {
  //   // Check if the permission is already in the selectedPermissions array
  //   const permissionIndex = selectedPermissions.indexOf(permission);

  //   // Create a copy of the selectedPermissions array to avoid mutating state directly
  //   const updatedPermissions = [...selectedPermissions];

  //   // If the permission is already in the array, remove it
  //   if (permissionIndex !== -1) {
  //     updatedPermissions.splice(permissionIndex, 1);
  //   } else {
  //     // If the permission is not in the array, add it
  //     updatedPermissions.push(permission);
  //   }

  //   // Update the selectedPermissions state with the modified array
  //   setSelectedPermissions(updatedPermissions);
  //   // setPermissions(selectedPermissions)
  // };

  const updateHandler = () => {
    if (selectedUser && selectedUser._id && selectedPermissions.length > 0) {
      const userData = {
        // permissions: permissions,
        permissions: selectedPermissions,
      };
      dispatch(updateUser({ id: selectedUser._id, userData }));
    } else {
      toast.error("Please select a User and a Permission to proceed!", {
        position: "top-center",
      });
    }
  };

  // console.log("selectedUserName : ", selectedUser.userName);
  // console.log("selectedUserID : ", selectedUser._id);
  // console.log("Selected permissions : ", permissions);
  // console.log("UserPermissions : ", selectedUser.permissions);
  // console.log("Selected User Permissions : ", selectedUser.selectedPermissions);
  // console.log("Selected Permissions : ", selectedPermissions);

  return (
    <Container fluid className="my-5">
      <h2 style={{ fontWeight: "bold" }} className="mb-5 text-center">
        Master Setup
      </h2>
      <>
        {isGetAllUsersLoading || isUpdateLoading ? (
          <Loader />
        ) : (
          <Form>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    as="h4"
                    className="py-3 text-center text-black fw-bold"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Employee Access
                  </Card.Header>

                  <Card.Body>
                    <Row className="py-3">
                      <Col sm={7} md={7} lg={7}>
                        <Form.Group controlId="userName">
                          <Form.Label className="text-bold text-black fw-bold">
                            Select Employee
                          </Form.Label>
                          <Form.Control
                            as="select"
                            type="select"
                            value={userName}
                            onChange={(e) => handleEmployeeSelect(e)}
                          >
                            <option value="" className="pb-2">
                              Select Employee
                            </option>
                            {allUsers &&
                              allUsers.map((user) => (
                                <option key={user._id} value={user.userName}>
                                  {user.userName}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>

                        {/* <Row>
                        <Col sm={12} md={12} lg={12} className="text-left">
                          <Form.Group controlId="userName">
                            <Form.Label className="text-bold p-3 text-black fw-bold">
                              Users
                            </Form.Label>
                            <Form.Control
                              as="select"
                              type="select"
                              // className="fw-bold"
                              placeholder="Enter Employee Name"
                              value={userName}
                              onChange={(e) => handleEmployeeSelect(e)}
                            >
                              <option value="" disabled>
                                Select User
                              </option>

                              {allUsers &&
                                allUsers.map((employee) => (
                                  <option
                                    key={employee._id}
                                    value={employee.fullName}
                                  >
                                    {employee.fullName}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row> */}
                      </Col>

                      <Col sm={5} md={5} lg={5}>
                        <Form.Label className="text-bold text-black fw-bold">
                          Access Permissions
                        </Form.Label>
                        {/* if no user is selected checkboxes fields won't show */}

                        {selectedUser.userName ? (
                          <>
                            <Form.Group>
                              {/* <Form.Check
                            type="checkbox"
                            
                            checked={selectedPermissions?.includes(
                              "analytics"
                            )}
                            onChange={() => handleCheckboxChange("analytics")}
                            label="Analytics"
                          >
                            
                          </Form.Check> */}

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  style={{ cursor: "pointer" }}
                                  className="fw-bold text-black"
                                  onClick={() => setOpnePassport(!openPassport)}
                                >
                                  {openPassport ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    // className="fw-bold"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setOpnePassport(!openPassport)
                                    }
                                  >
                                    &nbsp; Passport
                                  </span>
                                </Form.Check.Label>

                                {openPassport && (
                                  <Form.Check
                                    type="checkbox"
                                    // checked={permissions.includes("createPassport")}
                                    checked={selectedPermissions?.includes(
                                      "createPassport"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("createPassport")
                                    }
                                    label="Create Passport"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Create Passport
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openPassport && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "passportList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("passportList")
                                    }
                                    label="Passport List"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Passport List
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openPassport && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "dueCollectionList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("dueCollectionList")
                                    }
                                    label="Due Collection"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Due Collection
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                              </Form.Check>

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  className="fw-bold text-black"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setOpenVisa(!openVisa)}
                                >
                                  {openVisa ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setOpenVisa(!openVisa)}
                                  >
                                    &nbsp; Visa
                                  </span>
                                </Form.Check.Label>

                                {openVisa && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "createVisa"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("createVisa")
                                    }
                                    label="Create Visa"
                                  ></Form.Check>
                                )}
                                {openVisa && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "visaList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("visaList")
                                    }
                                    label="Visa List"
                                  ></Form.Check>
                                )}
                              </Form.Check>

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  className="fw-bold text-black"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setOpenAgent(!openAgent)}
                                >
                                  {openAgent ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setOpenAgent(!openAgent)}
                                  >
                                    &nbsp; Agent
                                  </span>
                                </Form.Check.Label>

                                {openAgent && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "createAgent"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("createAgent")
                                    }
                                    label="Create Agent"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Create Agent
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                                {openAgent && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "agentList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("agentList")
                                    }
                                    label="Agent List"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Agent List
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                              </Form.Check>

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  className="fw-bold text-black"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setOpenOfficeAgent(!openOfficeAgent)
                                  }
                                >
                                  {openOfficeAgent ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setOpenOfficeAgent(!openOfficeAgent)
                                    }
                                  >
                                    &nbsp; Office Agent
                                  </span>
                                </Form.Check.Label>

                                {openOfficeAgent && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "createEmployee"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("createEmployee")
                                    }
                                    label="Create Office Agent"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Create Office Agent
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openOfficeAgent && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "employeeList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("employeeList")
                                    }
                                    label="Office Agent List"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Office Agent List
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                              </Form.Check>

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  className="fw-bold text-black"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setOpenDeliveryOffice(!openDeliveryOffice)
                                  }
                                >
                                  {openDeliveryOffice ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setOpenDeliveryOffice(!openDeliveryOffice)
                                    }
                                  >
                                    &nbsp; Delivery Office
                                  </span>
                                </Form.Check.Label>

                                {openDeliveryOffice && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "createDeliveryOffice"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        "createDeliveryOffice"
                                      )
                                    }
                                    label="Create Delivery Office"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Create Delivery Office
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                                {openDeliveryOffice && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "deliveryOfficeList"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("deliveryOfficeList")
                                    }
                                    label="Delivery Office List"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Delivery Office List
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                              </Form.Check>

                              <Form.Check type="checkbox">
                                {/* <Form.Check.Input type="checkbox" /> */}
                                <i
                                  variant="primary"
                                  className="fw-bold text-black"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setOpenAccounts(!openAccounts)}
                                >
                                  {openAccounts ? "-" : "+"}
                                </i>
                                <Form.Check.Label>
                                  <span
                                    className="text-black"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setOpenAccounts(!openAccounts)
                                    }
                                  >
                                    &nbsp; Accounts
                                  </span>
                                </Form.Check.Label>

                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "dailyExpense"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("dailyExpense")
                                    }
                                    label="Daily Expense"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Daily Expense
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "salaryExpense"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("salaryExpense")
                                    }
                                    label="Salary Expense"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Salary Expense
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "totalMonthlyExpenses"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        "totalMonthlyExpenses"
                                      )
                                    }
                                    label="Total Monthly Expenses"
                                  ></Form.Check>
                                )}

                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "incomeScreen"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("incomeScreen")
                                    }
                                    label="Income Screen"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                <Form.Check.Label className="text-black">
                                  Income Screen
                                </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "dailyExpenseEntry"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("dailyExpenseEntry")
                                    }
                                    label="Daily Expense Entry"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                  <Form.Check.Label className="text-black">
                                    Daily Expense Entry
                                  </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "salaryEntry"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("salaryEntry")
                                    }
                                    label="Salary Entry"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                  <Form.Check.Label className="text-black">
                                    Salary Entry
                                  </Form.Check.Label> */}
                                  </Form.Check>
                                )}

                                {openAccounts && (
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedPermissions?.includes(
                                      "incomeEntry"
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange("incomeEntry")
                                    }
                                    label="Income Entry"
                                  >
                                    {/* <Form.Check.Input type="checkbox" />
                                  <Form.Check.Label className="text-black">
                                    Income Entry
                                  </Form.Check.Label> */}
                                  </Form.Check>
                                )}
                              </Form.Check>
                            </Form.Group>
                          </>
                        ) : null}
                      </Col>
                    </Row>
                  </Card.Body>

                  <Row className="mx-3 mb-4">
                    <Button
                      variant="outline-primary"
                      // type="submit"
                      onClick={updateHandler}
                    >
                      Grant Access
                    </Button>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </>
    </Container>
  );
};

export default MasterSetup;
